import React from "react";
import classNames from "classnames";
import { AppLink } from "@base";
import { m } from "framer-motion";
import Icon from "./Icon";

const DonationBanner = ({ name, amount, fundraiser, delay, style }) => {
  return (
    <m.li
      animate={{ y: "100%", opacity: 0, transition: { delay } }}
      className={classNames(
        "text-uppercase font-serif absolute inset-0 z-10 flex items-center bg-black p-6 text-sm font-semibold text-white"
      )}
      style={style}
    >
      <Icon name="donation" className={classNames("mr-4 h-8 w-8", {})} />
      <span>
        {`${name} donated $${amount.toLocaleString()}`}{" "}
        {fundraiser && (
          <span>
            to{" "}
            <AppLink
              className={classNames("underline-2", {})}
              to={`/${fundraiser.slug}`}
            >
              {fundraiser.title}
            </AppLink>
          </span>
        )}
      </span>
    </m.li>
  );
};

DonationBanner.defaultProps = {};

export default DonationBanner;
